"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageListMore = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var ListMore_1 = require("../ListMore");
var colors_1 = require("../../themes/main/colors");
var styles_1 = __importDefault(require("./styles"));
exports.ImageListMore = react_1.default.memo(function (props) {
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsx)(ListMore_1.ListMore, __assign({}, props, { component: (0, jsx_runtime_1.jsx)("img", { className: classes.image, alt: "" }), backgroundColor: colors_1.materialColors.grey[200] })));
});
